import React, { useEffect, useState } from "react";
import { ShieldAlert, LogOut } from "lucide-react";
import { getImpersonationState, exitImpersonation } from "../utils/impersonation";

export const ImpersonationBanner = () => {
  const [state, setState] = useState(getImpersonationState());
  const [remaining, setRemaining] = useState("");
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const tick = () => {
      const s = getImpersonationState();
      setState(s);
      if (!s.active) return;
      const expMs = s.expiresAt ? Date.parse(s.expiresAt) : 0;
      const left = expMs - Date.now();
      // Auto-exit ~1 min before the token dies so the admin lands back cleanly
      if (expMs && left < 60 * 1000) {
        exitImpersonation();
        return;
      }
      setRemaining(`${Math.max(1, Math.round(left / 60000))} min left`);
    };
    tick();
    const id = setInterval(tick, 15000);
    window.addEventListener("storage", tick);
    return () => { clearInterval(id); window.removeEventListener("storage", tick); };
  }, []);

  if (!state.active) return null;

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-[200] w-full bg-amber-500 text-black px-3 py-1.5 flex items-center justify-center gap-2 text-sm font-medium shadow-md"
    >
      <ShieldAlert className="w-4 h-4 shrink-0" />
      <span className="truncate">
        You are viewing as <strong>{state.customerName}</strong>
        <span className="hidden sm:inline text-black/60"> · {remaining}</span>
      </span>
      <button
        data-testid="exit-impersonation-btn"
        onClick={async () => { setExiting(true); await exitImpersonation(); }}
        disabled={exiting}
        className="ml-2 inline-flex items-center gap-1 rounded-full bg-black text-amber-400 px-3 py-0.5 text-xs font-semibold hover:bg-black/80 disabled:opacity-60"
      >
        <LogOut className="w-3 h-3" />
        {exiting ? "Exiting…" : "Exit support mode"}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
